import $ from "jquery";

function showFlash(type, message) {
  const id = type === "error" ? "fx-conteneur-error" : "fx-conteneur-notice";
  const flashClass =
    type === "error"
      ? "fx-flash-top-right fx-flash-error fx-flash-message"
      : "fx-flash-top-right fx-flash-success fx-flash-message";

  // Supprime les anciens messages du même type
  $(`#${id}`).remove();

  // Injecte le HTML
  const html = `
    <div id="${id}" class="${flashClass}"
         data-controller="flash"
         data-flash-target="container"
         data-flash-timeout-value="3500"
         data-action="mouseenter->flash#mouseenter mouseleave->flash#mouseleave">
      <button class="fx-flash-close-button" data-action="flash#dismissManually">&times;</button>
      <div class="fx-inline-message"><span>${message}</span></div>
      <div class="fx-progress-bar" data-flash-target="progressBar"></div>
    </div>
  `;
  $("body").append(html);

}

// Rendre accessible globalement
window.showFlash = showFlash;
